import {
  FETCH_DELETION_REQUESTS,
  FETCH_DELETION_REQUESTS_SUCCESS,
  FETCH_DELETION_REQUESTS_FAILED,
  REQUEST_ACCOUNT_DELETION,
  REQUEST_ACCOUNT_DELETION_SUCCESS,
  REQUEST_ACCOUNT_DELETION_FAILED,
  FETCH_MY_DELETION_REQUEST,
  EDIT_DELETION_REQUEST
} from "../store/types";
import { firebase } from '../config/configureFirebase';
import { onValue, set, update, remove } from "firebase/database";
import { deleteUser } from './usersactions';

export const DELETION_STATUS = {
  PENDING: 'pending',
  APPROVED: 'approved',
  REJECTED: 'rejected'
};

// Users no longer delete their own account directly. They file a request here and an
// admin approves it, which is what actually removes users/{uid} (and via the userDelete
// trigger, the Firebase Auth account).
export const requestAccountDeletion = (profile, reason) => async (dispatch) => {

  const {
    singleDeletionRequestRef
  } = firebase;

  dispatch({
    type: REQUEST_ACCOUNT_DELETION,
    payload: null
  });

  if (!profile || !profile.uid) {
    dispatch({
      type: REQUEST_ACCOUNT_DELETION_FAILED,
      payload: "Missing user profile."
    });
    return { ok: false };
  }

  const entry = {
    uid: profile.uid,
    name: [profile.firstName, profile.lastName].filter(Boolean).join(' ').trim() || null,
    email: profile.email || null,
    mobile: profile.mobile || null,
    usertype: profile.usertype || null,
    reason: reason || null,
    status: DELETION_STATUS.PENDING,
    requestDate: new Date().getTime()
  };

  try {
    await set(singleDeletionRequestRef(profile.uid), entry);
    dispatch({
      type: REQUEST_ACCOUNT_DELETION_SUCCESS,
      payload: entry
    });
    return { ok: true, request: entry };
  } catch (error) {
    dispatch({
      type: REQUEST_ACCOUNT_DELETION_FAILED,
      payload: error.message || "Could not submit deletion request."
    });
    return { ok: false, message: error.message };
  }
};

// Lets a user withdraw a still-pending request from the app.
export const cancelAccountDeletionRequest = (uid) => async (dispatch) => {

  const {
    singleDeletionRequestRef
  } = firebase;

  try {
    await remove(singleDeletionRequestRef(uid));
    dispatch({
      type: FETCH_MY_DELETION_REQUEST,
      payload: null
    });
    return { ok: true };
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

// Subscribes to the signed-in user's own request so the profile screen can show
// "pending admin approval" instead of the delete button.
export const fetchMyDeletionRequest = (uid) => (dispatch) => {

  const {
    singleDeletionRequestRef
  } = firebase;

  onValue(singleDeletionRequestRef(uid), snapshot => {
    dispatch({
      type: FETCH_MY_DELETION_REQUEST,
      payload: snapshot.val()
    });
  });
};

export const fetchDeletionRequests = () => (dispatch) => {

  const {
    deletionRequestsRef
  } = firebase;

  dispatch({
    type: FETCH_DELETION_REQUESTS,
    payload: null
  });

  onValue(deletionRequestsRef, snapshot => {
    const data = snapshot.val();
    if (data) {
      const arr = Object.keys(data).map(i => ({ ...data[i], id: i, uid: data[i].uid || i }));
      dispatch({
        type: FETCH_DELETION_REQUESTS_SUCCESS,
        payload: arr.reverse()
      });
    } else {
      dispatch({
        type: FETCH_DELETION_REQUESTS_FAILED,
        payload: "No deletion requests available."
      });
    }
  });
};

// Approval is the only path that actually destroys the account. The request row is kept
// as an audit record after the user node is gone.
export const approveDeletionRequest = (request, adminUid) => async (dispatch) => {

  const {
    singleDeletionRequestRef
  } = firebase;

  const uid = request.uid || request.id;

  dispatch({
    type: EDIT_DELETION_REQUEST,
    payload: request
  });

  try {
    await update(singleDeletionRequestRef(uid), {
      status: DELETION_STATUS.APPROVED,
      processedBy: adminUid || null,
      processDate: new Date().getTime()
    });
    dispatch(deleteUser(uid));
    return { ok: true };
  } catch (error) {
    return { ok: false, message: error.message };
  }
};

export const rejectDeletionRequest = (request, adminUid, note) => async (dispatch) => {

  const {
    singleDeletionRequestRef
  } = firebase;

  const uid = request.uid || request.id;

  dispatch({
    type: EDIT_DELETION_REQUEST,
    payload: request
  });

  try {
    await update(singleDeletionRequestRef(uid), {
      status: DELETION_STATUS.REJECTED,
      processedBy: adminUid || null,
      processDate: new Date().getTime(),
      adminNote: note || null
    });
    return { ok: true };
  } catch (error) {
    return { ok: false, message: error.message };
  }
};
